import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postGetResourcesByProjectBusinessId = async (
  businessId,
  filterEmployerBusinessIds
) => {
  const apiPath = `resource/business-resources/${businessId}/resources-in-projects-of-business`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: { filterEmployerBusinessIds },
  });

  const response = await axios(signedRequest);

  return response.data;
};
